import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { REPORTS } from '@elementary/common-ui/constants/queryKeys';
import { Report } from './useInitializingReportsPolling';

const useInitializingReports = () => {
  // this useQuery is only for getting the data fetched by useInitializingReportsPolling
  const { data: reportsData } = useQuery<Report[]>([REPORTS], () => [], {
    enabled: false,
  });

  const isReportInitializing = useCallback(
    (envId: string) =>
      reportsData?.find((report) => report.envId === envId)?.isReportReady ===
      false,
    [reportsData],
  );

  return { reportsData, isReportInitializing };
};

export default useInitializingReports;
